<template>
    <div id="app">
        <transition
                name="fade"
                mode="out-in">
            <Navbar v-if="showNavbar"/>
        </transition>
        <main class="mt-5">
            <transition
                    name="fade"
                    mode="out-in">
                <router-view/>
            </transition>
        </main>
    </div>
</template>

<script>
    import Navbar from "./components/Navbar.vue"

    export default {
        components: {
            Navbar
        },
        computed: {
            showNavbar() {
                return this.$store.state.user !== null && !['/login', '/sign-in'].some(i => i === this.$route.path)
            }
        }
    }
</script>

